import React from "react";
import { clsx } from "clsx";

const AboutHeadings = ({
  subtitle,
  title,
  textAlign = "center",
  containerClassName,
  subtitleClassName,
  titleClassName,
  spacing = "tight",
}) => {
  // Container styles
  const containerBaseStyles = clsx(
    "w-full flex flex-col",
    {
      "items-start text-left": textAlign === "left",
      "items-center text-center": textAlign === "center",
      "items-end text-right": textAlign === "right",
    },
    {
      "gap-1": spacing === "tight",
      "gap-2": spacing === "default",
      "gap-3": spacing === "loose",
    }
  );

  // Subtitle styles
  const subtitleBaseStyles = clsx(
    "font-poppins font-medium capitalize text-[#29AAE1] tracking-[0.125rem]",
    "text-[0.875rem] leading-[1.125rem] sm:text-[1rem] sm:leading-[1.25rem] md:text-[1.125rem] md:leading-[1.375rem] lg:text-[1.25rem] lg:leading-[1.5rem]"
  );

  // Title styles
  const titleBaseStyles = clsx(
    "font-raleway font-medium capitalize text-[#08121A] align-middle py-2",
    "tracking-[2.5%]", // letter spacing
    "text-[1.5rem] leading-[2.25rem]", // Mobile base
    "sm:text-[2rem] sm:leading-[2.75rem]", // Tablet
    "md:text-[2.25rem] md:leading-[3rem]", // Medium
    "lg:text-[2.375rem] lg:leading-[3.5rem]" // 38px / 56px for large screens
  );

  const finalContainerClasses = clsx(containerBaseStyles, containerClassName);
  const finalSubtitleClasses = clsx(subtitleBaseStyles, subtitleClassName);
  const finalTitleClasses = clsx(titleBaseStyles, titleClassName);

  return (
    <div
      className={finalContainerClasses}
      data-aos="fade-up"
      data-aos-duration="500"
    >
      {subtitle && (
        <h3
          className={finalSubtitleClasses}
          data-aos="fade-down"
          data-aos-delay="100"
        >
          {subtitle}
        </h3>
      )}
      <h1 className={finalTitleClasses} data-aos="fade-up" data-aos-delay="200">
        {title}
      </h1>
    </div>
  );
};

export default AboutHeadings;
